import React, { forwardRef } from 'react'
import ConfirmPopup from './ConfirmPopup'

export default forwardRef(function DeletePopup(props, ref) {
    return (
        <ConfirmPopup
            type="delete"
            {...props}
            onOk={props.onDelete}
            ref={ref}
        />
    )
})
